<template>
	<component :is="componentName" href @click.prevent="toggleAccountMenu" class="account"><div class="name">{{ currentUser.name || 'No Accounts Found' }}<span class="fa fa-retweet"></span></div>{{ currentAccount.name }}</component>
</template>

<script>

import { mapGetters, mapState } from 'vuex';

export default {

	name: 'HeaderAccount',

	computed: {

		...mapGetters([ 'accounts', 'currentAccount', 'currentUser' ]),

		...mapState({
			accountMenuOpen: state => state.layout.accountMenuOpen,
		}),

		componentName() {
			return this.accounts.length > 1 ? 'a' : 'div';
		},

	},

	methods: {

		toggleAccountMenu() {
			if (this.accounts.length > 1) {
				this.$store.dispatch(this.accountMenuOpen ? 'closeAccountMenu' : 'openAccountMenu');
			}
		},

	}

};
</script>
